module.exports = __webpack_public_path__ + "img/icon_shoulian_hover@2x.caa4c185.png";